import axios from "./axiosConfig.js";

// Obtener estadísticas de las provincias
export const getProvinceStats = async () => {
  return await axios.get("/sales-location-match/stats/provinces");
};

// Obtener estadísticas de cantones por provincia (diurno)
export const getCantonStats = async (province) => {
  return await axios.get(`/sales-location-match/stats/cantons/${province}`);
};

// Obtener estadísticas de cantones por provincia (nocturno)
export const getCantonStatsNocturno = async (province) => {
  return await axios.get(
    `/sales-location-match/stats/cantons/${province}/nocturno`
  );
};

// Obtener estadísticas de parroquias por provincia y cantón
export const getParishStats = async (province, canton) => {
  return await axios.get(
    `/sales-location-match/stats/parishes/${province}/${canton}`
  );
};

// Obtener estadísticas de concesionarios por parroquia (diurno)
export const getParishDealersStatsDiurno = async () => {
  return await axios.get("/sales-location-match/stats/parish-dealers/diurno");
};

// Obtener estadísticas de concesionarios por parroquia (nocturno)
export const getParishDealersStatsNocturno = async () => {
  return await axios.get("/sales-location-match/stats/parish-dealers/nocturno");
};

// Obtener estadísticas globales
export const getGlobalStats = async () => {
  return await axios.get("/sales-location-match/global-stats");
};

// Obtener distancias entre parroquias y concesionarios (diurno)
export const getParishDealerDistancesDiurno = async () => {
  return await axios.get(
    "/sales-location-match/stats/parish-dealer-distances/diurno"
  );
};

// Obtener distancias entre parroquias y concesionarios (nocturno)
export const getParishDealerDistancesNocturno = async () => {
  return await axios.get(
    "/sales-location-match/stats/parish-dealer-distances/nocturno"
  );
};

// Obtener vehículos específicos por parroquia y tipo de tiempo (diurno/nocturno)
export const getParishVehicles = async (
  province,
  canton,
  parish,
  timeOfDay,
  selectedDealer = null
) => {
  return await axios.get(`/sales-location-match/vehicles/parish`, {
    params: {
      province,
      canton,
      parish,
      timeOfDay,
      includeDistances: true,
      dealer: selectedDealer,
    },
  });
};
